import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header'; 
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import imageCompression from 'browser-image-compression';

function VerifyInvitationInfoConfirm() {
  const { menu, toggleMobileMenu } = useAppLayout();
  
  const loggedInUserId = localStorage.getItem("user_id");
  const loggedFamilyAdmin = localStorage.getItem("family_admin");
  const navigate = useNavigate();
const queryClient = useQueryClient();


const [message, setMessage] = useState('');
    
      const [profile, setProfile] = useState({
          name: '',
          last_name: '',
          phone_number: '',
          email: '',
          profile_image: ''
          });
  
          
          const {
            data: dataProfile,
            isLoading: isLoadingProfile,
            isError: isErrorProfile,
          } = useQuery({
            queryKey: ['userProfileDetails'],
            queryFn: async () => {
              
          
              const res = await axios.get(`${API_URL}/register-user-details-api`, {
                withCredentials: true,
              });
          
              return res.data;
            },
             
            staleTime: 0,
            cacheTime: Infinity,
          });
        
        
  
        useEffect(() => {
            if (dataProfile) {
              if (dataProfile.Status === "Success") {
                const user = dataProfile.user;
          
                setProfile({
                  name: user.name || '',
                  last_name: user.last_name || '',
                  phone_number: user.phone_number || '',
                  email: user.email || '',
                  profile_image: user.profile_image || '',
                });
              } else {
                setMessage("Failed to load user data");
              }
            }
          }, [dataProfile]);
  
  

      
  const [previewImage, setPreviewImage] = useState(null);
  


  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 800,
        useWebWorker: true,
      };
  
      // Compress → Blob
      const compressedBlob = await imageCompression(file, options);
  
      // Convert → File
      const compressedFile = new File([compressedBlob], file.name, {
        type: compressedBlob.type,
        lastModified: Date.now(),
      });
  
      // Preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(compressedFile);
  
      // Save File in state
      setProfile((prev) => ({
        ...prev,
        profile_image: compressedFile,
      }));
  
    } catch (error) {
      console.error("Image compression failed:", error);
      toast.error("Image upload failed. Please try again.");
    }
  };
  
  


  /*const handleChange = (e) => {
    const { name, value } = e.target;
  
    // For passwords
    if (name === "password" || name === "confirm_password") {
      setValues(prev => ({ ...prev, [name]: value }));
    } else {
      // For profile info
      setProfile(prev => ({ ...prev, [name]: value }));
    }
  };*/


  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "password" || name === "confirm_password") {
      setValues((prev) => ({ ...prev, [name]: value }));
    } else if (name === "phone_number") {
      handlePhoneChange(e); // call the custom phone handler
    } else {
      setProfile((prev) => ({ ...prev, [name]: value }));
    }
  };


  const [values, setValues] = useState({
    password: '',
    confirm_password: '',
  });


  const compressTo100KB = async (file) => {
    let quality = 0.9;
    let compressed = file;
  
    while (true) {
      const options = {
        maxSizeMB: 0.1,
        initialQuality: quality,
        maxWidthOrHeight: 600,
        useWebWorker: true,
      };
  
      compressed = await imageCompression(compressed, options);
  
      if (compressed.size / 1024 <= 100 || quality <= 0.1) break;
  
      quality -= 0.1;
    }
  
    // Convert Blob → File
    return new File([compressed], file.name, {
      type: compressed.type,
      lastModified: Date.now(),
    });
  };
  

const [phoneMessage, setPhoneMessage] = useState("");

  const handlePhoneChange = (e) => {
    let value = e.target.value;
  
    // Detect spaces
    if (/\s/.test(value)) {
      setPhoneMessage("⚠️ Spaces are not allowed. They were removed automatically.");
    } else {
      setPhoneMessage("");
    }
  
    // Remove spaces
    value = value.replace(/\s+/g, "");
  
    // Allow only numbers and +
    if (!/^[0-9+]*$/.test(value)) return;
  
    // Auto-fix: 7XXXXXXXX → 07XXXXXXXX
    if (/^7\d{8}$/.test(value)) {
      value = "0" + value;
      setPhoneMessage("ℹ️ Added leading 0 automatically.");
    }
  
    // Prevent wrong first character
    if (value.length === 1 && value !== "0" && value !== "+") return;
  
    // Limit: 15 digits max (E.164)
    const digitsCount = value.replace(/\D/g, "").length;
    if (digitsCount > 15) return;
  
    setProfile((prev) => ({
      ...prev,
      phone_number: value,
    }));
  };


const [isUpdating, setIsUpdating] = useState(false);


const handleSubmit = async (e) => {
e.preventDefault();

const pw = values.password.trim();
const cpw = values.confirm_password.trim();

// Password validation
if (!pw || !cpw) {
  toast.error("Please fill both password fields");
  return;
}

// 2. Check if they match
if (pw !== cpw) {
  toast.error("Passwords do not match");
  return;
}

// 3. Check length
if (pw.length < 4) {
  toast.error("Password must be at least 4 characters");
  return;
}

setIsUpdating(true);

try {
  const formData = new FormData();
  formData.append('name', profile.name);
  formData.append('last_name', profile.last_name);
  formData.append('phone_number', profile.phone_number);
  formData.append('email', profile.email);

  if (pw) {
    formData.append('password', pw);
  }



    if (profile.profile_image instanceof File) {

      const finalImage = await compressTo100KB(profile.profile_image);
    
      formData.append('profile_image', finalImage);
    }

  const res = await axios.put(
    `${API_URL}/update-invited-user-profile-api`,
    formData,
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

  if (res.data.success) {
    toast.success("Profile updated successfully");
    queryClient.invalidateQueries(['checkInvitation']);
    navigate('/home');
  } else {
    toast.error(res.data.message || "Update failed");
  }
} catch (error) {
  console.error(error);
  toast.error("Something went wrong");
} finally {
  setIsUpdating(false);
}
};


  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 col-xl-7">
              {/* ✅ remove overflow-hidden (it can clip dropdowns) */}
              <div className="card shadow-sm border-0 rounded-4">
                {/* ✅ smaller header */}
                <div
                  className="px-3 py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(116,186,84,0.18), rgba(44,83,61,0.06))",
                    borderBottom: "1px solid rgba(44,83,61,0.12)",
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
                    <div>
                      <h5 className="mb-1 fw-bold">Update Your Info</h5>
                    </div>

                    <div className="text-end">
                      <div
                        className="badge px-3 py-2 rounded-pill"
                        style={{
                          background: "rgba(116,186,84,0.18)",
                          color: "#2C533D",
                          border: "1px solid rgba(44,83,61,0.18)",
                        }}
                      >
                        Step 2 of 2
                      </div>
                    </div>
                  </div>

                  <div className="mt-2">
                    <div className="progress" style={{ height: 7, borderRadius: 999, background: "rgba(44,83,61,0.12)" }}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "100%", background: "linear-gradient(90deg, #74BA54, #2C533D)" }}
                      />
                    </div>
                  </div>
                </div>

                {/* ✅ smaller body, extra bottom space so browser has room to open dropdown DOWN */}
                <div
                  className="card-body p-3 p-md-4"
                  style={{
                    paddingBottom: 28, // helps dropdown have space below
                  }}
                >
              
                    {/* ✅ tighter grid */}
                    <div className="row  ">

                    <form onSubmit={handleSubmit}>

                    <div className="row">
                        <div className="col-md-12">
                            <center>
                            <div 
                                className="position-relative d-inline-block" 
                                style={{ cursor: 'pointer' }} 
                                onClick={() => document.getElementById('uploadImageInput').click()}
                            >
                                {profile.profile_image && (
                                <div className="mb-3">
                                    <img 
                                    src={previewImage || `${API_URL}/images/${profile.profile_image}`} 
                                    alt="Profile" 
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '50%', 
                                        border: '2px solid #ccc' 
                                    }}
                                    
                                    />

                                </div>
                                )}

                                {/* Edit Icon */}
                                <span 
                                className="avatar-edit bg-transparent shadow-none" 
                                style={{ position: 'absolute', bottom: '5px', right: '5px', 
                                    backgroundColor: '#fff', borderRadius: '50%', padding: '6px', 
                                    boxShadow: '0px 0px 5px rgba(0,0,0,0.2)'
                                }}
                                >
                                <i className="fas fa-edit" style={{ color: '#184A2C', fontSize: '16px' }}></i>
                                </span>

                                {/* Hidden Input */}
                                <input 
                                id="uploadImageInput" 
                                type="file" 
                                accept="image/*" 
                                onChange={handleImageChange} 
                                style={{ display: 'none' }}
                                />
                            </div>
                            </center>
                        </div>
                        </div>



                    <div className="row">
                    <div className="col-6 col-md-6">
                    <label className="control-label">First Name</label>
                    <input type="text" name="name" value={profile.name} onChange={handleChange} placeholder="First Name" className="form-control mb-2" />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Last Name</label>
                    <input type="text" name="last_name" value={profile.last_name} onChange={handleChange} placeholder="Last Name" className="form-control mb-2" />
                    </div>
                    
                </div>

                <div className="row">
                    
                    <div className="col-6 col-md-6">
                    <label className="control-label">Your Phone Number</label>
                    <input type="text" name="phone_number" value={profile.phone_number} 
                    onChange={handleChange} placeholder="Phone Number" className="form-control mb-2" />
                    {phoneMessage && (
  <small className="text-warning d-block mt-1">{phoneMessage}</small>
)}
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Your Email</label>
                    <input type="email" name="email" readOnly value={profile.email} onChange={handleChange} placeholder="Email" className="form-control mb-2" />
                    </div>

                </div>

                <div className="row">
                    
                    <div className="col-6 col-md-6">
                    <label className="control-label">New Password</label>
                    <input
                        type="password"
                        name="password"
                        value={values.password}
                        onChange={handleChange}
                        placeholder="New Password"
                        className="form-control mb-2"
                        />
                    </div>
                    <div className="col-6 col-md-6">
                    <label className="control-label">Confirm Password</label>
                    <input
                            type="password"
                            name="confirm_password"
                            value={values.confirm_password}
                            onChange={handleChange}
                            placeholder="Confirm Password"
                            className="form-control mb-2"
                            />
                    </div>

                </div>
                
                
                    {/* ✅ tighter actions */}
                    <div className="d-flex justify-content-between mt-3">
                      <button
                        type="button"
                        className="btn btn-light border rounded-3 px-3 py-2"
                        onClick={() => navigate(-1)}
                        disabled={isUpdating}
                      >
                       Back
                      </button>

                      

                      <button type="submit" 
                      className="btn rounded-3 px-3 py-2 d-inline-flex align-items-center justify-content-center"
                       
                      style={{
                        minWidth: 120,
                        background: "linear-gradient(135deg, #74BA54, #2C533D)",
                        border: "none",
                        color: "#fff",
                      }}
                      disabled={isUpdating}>
                    {isUpdating ? "Updating..." : "Update"}
                    </button>

                    </div>

                </form>
                
                    </div>

                    
                    


                 
                </div>
              </div>







              <div style={{ height: 8 }} />
            </div>
          </div>
                                    
          </div>
        </div>


 
      
      </div>
    
  );
}

export default VerifyInvitationInfoConfirm;
